import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-link-about-bgt-viewer',
    templateUrl: './link-about-bgt-viewer.component.html',
    styleUrls: ['./link-about-bgt-viewer.component.scss'],
    imports: [RouterLink]
})
export class LinkAboutBgtViewerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
